<template>
  <div class="container">
    <el-card class="search-card">
      <el-row style="height:40px">
        <el-col :span="12">
          <el-form :inline="true" :model="searchParams">
            <el-form-item>
              <el-input placeholder="请输入用户名" type="text" size="small"
                v-model="searchParams.nickName" class="small" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入mobile" type="text" size="small"
                v-model="searchParams.mobile" class="small" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-search"
                @click="changePage(1)">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin: 0 10px">
      <el-pagination
        v-if="tableData.length > 0"
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="limit"
        style="float: right; margin: 0 0 20px 0"
        @current-change="changePage">
      </el-pagination>
      <el-table :data="tableData">
        <el-table-column
          v-for="col of tableColumns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="80">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="view(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      title="事件详情"
      :visible.sync="detailDialogVisible"
      width="40%"
      :before-close="handleClose">
       <vue-json-pretty :data="selectedRow" > </vue-json-pretty>
    </el-dialog>
  </div>
</template>
<script>

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

const tableColumns = [
  { prop: 'id', label: 'Id', width: 80 },
  { prop: 'app_id', label: 'AppId', width: 100},
  { prop: 'source_id', label: 'SourceId', width: 100 },
  // { prop: 'typeName', label: 'Type', width: 80 },
  { prop: 'nickname', label: 'NickName', width: 120 },
  { prop: 'genderName', label: 'Gender', width: 80 },
  { prop: 'birthday', label: 'Birthday', width: 120 },
  // { prop: 'avatar', label: 'Avatar', width: 100 },
  { prop: 'country_code', label: 'CountryCode', width: 120 },
  { prop: 'mobile', label: 'Mobile', width: 120 },
  { prop: 'lang', label: 'Lang', width: 100 },
  { prop: 'country', label: 'Country', width: 120 },
  { prop: 'province', label: 'Province', width: 120 },
  { prop: 'city', label: 'City', width: 150 },
  { prop: 'address', label: 'Address', width: 150 },
  { prop: 'lat', label: 'Lat', width: 120 },
  { prop: 'lng', label: 'Lng', width: 120 },
  { prop: 'status', label: 'Status', width: 80 },
  // { prop: 'created_ip', label: 'CreatedIp', width: 150 },
  { prop: 'created_at', label: 'CreatedAt', width: 200 },
  { prop: 'updated_at', label: 'UpdatedAt', width: 200 },
]

const typeMap = {
  0: 'Unknown',
  1: 'User',
  2: 'Robot',
}

const genderMap = {
  0: 'Unknown',
  1: 'Male',
  2: 'Female',
  3: 'Bisexual'
}

export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      page: 1,
      limit: 15,
      apps: [],
      searchParams: {
        nickName: '',
        mobile: '',
      },
      tableData: [],
      totalCount: 0,
      tableColumns: tableColumns,
      selectedRow: undefined,
      detailDialogVisible: false
    }
  },
  mounted() {
  },
  methods: {
    async searchUsers(page) {

      let offset = (page - 1) * this.limit

      let url = `/etp/v1.0/user/list?app_id=${this.$store.state.appId}&limit=${this.limit}&offset=${offset}`;

      let name  = this.searchParams.nickName.trim();
      let mobile = this.searchParams.mobile.trim();
      
      if (name) {
        url = url + `&nickname=${name}`
      }

      if (mobile) {
        url = url + `&mobile=${mobile}`;
      }

      let rst = await this.$http.get(url);

      let users = rst.data.data;
      users.forEach((user) => {
        user.birthday = user.birthday.split('T')[0];
        // user.typeName = typeMap[user.type];
        user.genderName = genderMap[user.gender];
      })

      this.tableData = users;
      this.totalCount = rst.data.total;

    },
    changePage(val) {
      this.searchUsers(val);
    },
    handleClose() {
      this.detailDialogVisible = false;
    },
    view(row) {
      this.selectedRow = row;
      this.detailDialogVisible = true;
    }
  }
}

</script>
<style lang="less" scoped>
  .search-card {
    margin: 10px;
  }

  .small {
    width: 200px;
  }
</style>
